export const checkIsInBetween = (number, start, end) => number >= start && number <= end;

export default checkIsInBetween;
